import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

// api's
import { getTeachers } from '../../api/teacherApi';


// components
import DynamicDataTable from '../../common/components/Common/DataListing';
import AssignSubjectsModal from './AssignSubjectsModal';


const TeachersListing = ({ onEdit, onCreate, onDelete, extraActions: parentActions, permissions }) => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  useEffect(() => {
    fetchTeachers();
  }, []);

  const fetchTeachers = async () => {
    setLoading(true);
    try {
      const data = await getTeachers();
      setTeachers(data);
    } catch (error) {
      toast.error("Failed to fetch teachers.");
    } finally {
      setLoading(false);
    }
  };

  const handleAssignSubjects = (teacher) => {
    setSelectedTeacher(teacher);
    setIsModalVisible(true);
  };

  // Teacher records have id = teacher.id, but UsersList handlers expect user.id.
  // Remap so that onEdit/onDelete receive the correct user ID.
  const handleEditTeacher = (teacher) => {
    const userId = teacher.user_id || teacher.user?.id;
    onEdit({ ...teacher, id: userId });
  };

  const handleDeleteTeacher = (teacherId) => {
    const teacher = teachers.find(t => t.id === teacherId);
    const userId = teacher?.user_id || teacher?.user?.id;
    if (userId) onDelete(userId);
  };

  const columns = [
    { field: 'user.name', header: 'Name' },
    { field: 'user.email', header: 'Email' },
    { field: 'designation', header: 'Designation' },
    { field: 'department', header: 'Department' },
  ];

  const extraActions = [
    {
      label: "Assign Subjects",
      icon: "pi pi-book",
      className: "p-button-info p-button-sm",
      handler: handleAssignSubjects,
    },
  ];

  // Remap parent actions so they receive { id: user_id, name: user.name } instead of teacher record
  const remappedParentActions = (parentActions || []).map((action) => ({
    ...action,
    handler: (teacher) => {
      const userId = teacher.user_id || teacher.user?.id;
      action.handler({ ...teacher, id: userId, name: teacher.user?.name });
    },
  }));

  const allActions = [...remappedParentActions, ...extraActions];

  return (
    <div>
      <DynamicDataTable
        data={teachers}
        columns={columns}
        extraActions={allActions}
        onCreate={onCreate}
        onEdit={handleEditTeacher}
        onDelete={handleDeleteTeacher}
        loading={loading}
        subject="Teachers"
        permissionSubject="User"
      />
      {selectedTeacher && (
        <AssignSubjectsModal
          visible={isModalVisible}
          onHide={() => setIsModalVisible(false)}
          teacher={selectedTeacher}
        />
      )}
    </div>
  );
};

export default TeachersListing;
